
/*
 * @Descripttion:
 * @version:
 * @Author: houhailong
 * @Date: 2023-05-21 09:52:22
 * @LastEditors: Aalon
 * @LastEditTime: 2023-05-21 10:02:26
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, distinctUntilChanged, tap, shareReplay } from 'rxjs/operators';
import { JwtService } from './jwt.service';
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { AccountType, User } from '../models/user.model';
import { StandardResponse } from '../models/standard-response';
import { AnonymousSubject } from 'rxjs/internal/Subject';

@Injectable({ providedIn: 'root' })
export class UserService {
  private currentUserSubject = new BehaviorSubject<User | null>(null);
  public currentUser = this.currentUserSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  //是否登录
  public isAuthenticated = this.currentUser.pipe(map((user) => !!user));

  //当前用户是否为patient
  public isPatientUser = this.currentUser.pipe(
    map((user) => user?.accountType == AccountType.Patient)
  );

  //跳转地址
  public redirectUrl: string = '';

  constructor(
    private readonly http: HttpService,
    private readonly jwtService: JwtService,
    private readonly router: Router
  ) {}

  //注册
  register(user: User) {
    return this.http.postJSON('/api/user/v1/user/anonymousUser/register', user);
  }

  //获取登录用户信息
  getCurrentUser() {
    return this.http.get('/api/user/v1/user/info').pipe(
      tap({
        next: (res) => this.setCurrentUser(res),
        error: () => this.purgeAuth(),
      }),
      shareReplay(1)
    );
  }
  //校验用户手机是否已注册
  checkPhoneExist(phone: string) {
    return this.http.get(
      `/api/user/v1/user/anonymousUser/checkPhoneExist/${phone}`
    );
  }
  //校验用户邮箱是否已注册
  checkEmailExist(email: string) {
    return this.http.get(
      `/api/user/v1/user/anonymousUser/checkEmailExist/${email}`
    );
  }
  //发送忘记密码邮件
  sendForgotPasswordEmail(email: string) {
    return this.http.postJSON(
      `/api/user/v1/user/anonymousUser/sendForgotPasswordEmail?email=${email}`,
      {}
    );
  }

  //重置密码
  resetPassword(resetPassword: {
    confirmPassword: string;
    identifier: string;
    password: string;
    sign: string;
  }) {
    return this.http.postJSON(
      `/api/user/v1/user/anonymousUser/resetPassword`,
      resetPassword
    );
  }

  setCurrentUser(res: StandardResponse) {
    this.currentUserSubject.next(res.data as unknown as User);
  }

  //上传
  uploadAvatar(uploadFile: { id: string; file: string }) {
    return this.http.postForm('/api/user/v1/user/uploadAvatar', uploadFile);
  }
  //退出
  logout(path: string = '/'): void {
    this.purgeAuth();
    void this.router.navigate([path]);
  }
  //清空用户信息
  purgeAuth(): void {
    this.jwtService.destroyToken();
    this.currentUserSubject.next(null);
  }
  //根据用户类型跳转
  goHome(callBack: any = null) {
    this.currentUser.subscribe((user) => {
      if (user) {
        if (user.accountType == AccountType.Admin) {
          this.purgeAuth();
          callBack && callBack();
        } else {
          this.router.navigate([
            `/${
              user?.accountType == AccountType.Patient ? 'user' : 'provider'
            }/${user?.id}`,
          ]);
        }
      }
    });
  }
   //根据用户类型跳转
   goOrder(callBack: any = null) {
    this.currentUser.subscribe((user) => {
      if (user) {
        if (user.accountType == AccountType.Admin) {
          this.purgeAuth();
          callBack && callBack();
        } else {
          this.router.navigate([
            `/user/${user?.id}/order`,
          ]);
        }
      }
    });
  }
  patientPageList(param:any){
    return this.http.postJSON(
      `/api/user/v1/admin/patient/pageList`,
      param
    );
  }
  getPatientAccountInfo(param:any){
    return this.http.postJSON(
      `/api/user/v1/provider/getPatientAccountInfo`,
      param
    );
  }
  getPatientInfo(id:any){
    return this.http.get(
      `/api/user/v1/patient/getPatientAccountInfo?id=${id}`,
      null
    );
  }
  getNextQuestionnaireDate(id:any){
    return this.http.get(
      `/api/user/v1/patient/nextQuestionnaireDate?id=${id}`,
      null
    );
  }
  unlink(patientId:any){
    return this.http.postJSON(
      `/api/user/v1/provider/unlink?patientId=${patientId}`,
      null
    );
  }

  //消息提醒列表
  messageList(){
    return this.http.get(
      `/api/user/v1/message/reminder/list`,
      null
    );
  }
  ///v1/message/updateInviteStatus
  updateInviteStatus(id:any,inviteStatus:any){
    return this.http.postJSON(
      `/api/user/v1/message/updateInviteStatus?id=${id}&inviteStatus=${inviteStatus}`,
      null
    );
  }


}
